import request from '@/utils/request'

export function getSHBudgetList(params, isNotify) {
  return request({
    url: '/api/getSHBudgetList_new',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getSHBudgetSign (params, isNotify) {
  return request({
    url: '/api/getSHBudgetSign',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
export function getSHBudgetTotalSign (params, isNotify) {
  return request({
    url: '/api/getSHBudgetTotalSign',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getSHBudgetCompanyList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetCompanyList_new',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getSHBudgetSum (params, isNotify) {
  return request({
    url: '/api/getSHBudgetSum',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getSHBudgetComp (params, isNotify) {
  return request({
    url: '/api/getSHBudgetComp',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

export function getSHBudgetCompHistory (params, isNotify) {
  return request({
    url: '/api/getSHBudgetCompHistory',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}


export function saveSHBudgetSign (params, isNotify) {
  return request({
    url: '/api/saveSHBudgetSign',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
} 


export function saveSHBudget (params, isNotify) {
  return request({
    url: '/api/saveSHBudget_new',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
} 

export function savePerformance (params, isNotify) {
  return request({
    url: '/api/savePerformance',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
} 

export function getSHBudgetCompList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetCompList_new',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 양식 관련 API 

// 양식 리스트 조회
export function getSHBudgetDivList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetDivList_new',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}
// 구분별 항목 조회
export function getSHBudgetDivItemList (params, isNotify) {
  return request({
    url: '/api/getSHBudgetDivItemList_new',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

// 양식 저장
export function saveSHBudgetDataDiv (params, isNotify) {
  return request({
    url: '/api/saveSHBudgetDataDiv',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

//양식 적용 applySHBudgetDataDiv
export function applySHBudgetDataDiv (params, isNotify) {
  return request({
    url: '/api/applySHBudgetDataDiv',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

//양식 copy
export function copySHBudgetDataDiv (params, isNotify) {
  return request({
    url: '/api/copySHBudgetDataDiv',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 구분 저장
export function saveSHBudgetDiv (params, isNotify) {
  return request({
    url: '/api/saveSHBudgetDiv',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}


// 구분 항목 저장
export function saveSHBudgetDivItem (params, isNotify) {
  return request({
    url: '/api/saveSHBudgetDivItem',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 양식 삭제
export function deleteSHBudgetDataDiv (params, isNotify) {
  return request({
    url: '/api/deleteSHBudgetDataDiv',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 구분 삭제
export function deleteSHBudgetDiv (params, isNotify) {
  return request({
    url: '/api/deleteSHBudgetDiv',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

// 항목 삭제
export function deleteSHBudgetDivItem (params, isNotify) {
  return request({
    url: '/api/deleteSHBudgetDivItem',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function getRptSHBudgetNewManage (params) {
  let responseType = "blob"
  return request({
    url: '/api/getRptSHBudgetNewManage',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType
  })
}


export function getRptSHBudgetCompManage (params) {
  let responseType = "blob"
  return request({
    url: '/api/getRptSHBudgetCompManage',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType
  })
}

export function getSHBudgetDistributeRatio (params) {
  return request({
    url: '/api/getSHBudgetDistributeRatio',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
  })
}